import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Hero() {
  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="container mx-auto px-4 py-8 md:py-12" data-id="element-185">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="relative rounded-2xl overflow-hidden bg-gradient-to-r from-slate-900/95 to-slate-900/70 min-h-[500px] md:min-h-[600px] flex items-center" style={{
      backgroundImage: 'url(https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=1600&q=80)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-186">
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-transparent" data-id="element-187"></div>

        <div className="relative z-10 max-w-3xl px-6 md:px-12 py-12 md:py-16" data-id="element-188">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-189">
            Prodajte vozilo brez stresa, pogajanj in izgube časa.
          </h1>

          <p className="text-lg md:text-xl text-white/90 mb-8 leading-relaxed" data-id="element-190">
            Autopoint za vas vodi celoten postopek prodaje — od cenitve do
            nakazila kupnine.
          </p>

          <div className="mb-8" data-id="element-191">
            <button onClick={scrollToForm} className="px-8 py-3.5 bg-[#1EB6E8] text-white rounded-md font-medium hover:bg-[#1aa3d1] transition-colors text-lg" data-id="element-192">
              Prodaj vozilo
            </button>
          </div>

          <div className="flex flex-wrap gap-3" data-id="element-193">
            {['Brez skritih stroškov', 'Varna prodaja', 'Ponudba v 72 urah'].map(badge => <div key={badge} className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20" data-id="element-194">
                <Check className="w-4 h-4 text-emerald-400" data-id="element-195" />
                <span className="text-white text-sm font-medium" data-id="element-196">{badge}</span>
              </div>)}
          </div>
        </div>
      </motion.div>
    </section>;
}